export default __webpack_public_path__ + "static/7-microchip-865fd4a3740b65e33ecb9ddbf65c61f7.png";